import { motion } from "framer-motion";
import { Crown, Star } from "lucide-react";
import AnimatedCounter from "./AnimatedCounter";

interface SalonsSlideProps {
  count: number;
}

const SalonsSlide = ({ count }: SalonsSlideProps) => {
  if (count === 0) {
    return (
      <div className="flex flex-col items-center justify-center text-center px-6">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 200 }}
          className="mb-6"
        >
          <Crown className="w-16 h-16 text-amber-400" />
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="text-2xl font-bold text-background mb-4"
        >
          Secret Salons Await
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="text-background/70"
        >
          Exclusive experiences are waiting for you in 2026!
        </motion.p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center text-center px-6">
      {/* VIP badge */}
      <motion.div
        initial={{ scale: 0, rotate: -20 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ type: "spring", stiffness: 150 }}
        className="relative mb-6"
      >
        <motion.div
          className="w-24 h-24 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center"
          animate={{
            boxShadow: [
              "0 0 20px rgba(251, 191, 36, 0.3)",
              "0 0 40px rgba(251, 191, 36, 0.6)",
              "0 0 20px rgba(251, 191, 36, 0.3)",
            ],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <Crown className="w-12 h-12 text-primary" />
        </motion.div>
        
        {/* Floating stars */}
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute"
            style={{
              top: `${20 + Math.random() * 60}%`,
              left: `${10 + Math.random() * 80}%`,
            }}
            initial={{ opacity: 0, scale: 0 }}
            animate={{
              opacity: [0, 1, 0],
              scale: [0, 1, 0],
              y: [0, -10, 0],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              delay: i * 0.3,
            }}
          >
            <Star className="w-4 h-4 text-amber-300 fill-amber-300" />
          </motion.div>
        ))}
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="px-4 py-1 bg-amber-500/20 rounded-full mb-4"
      >
        <span className="text-sm font-medium text-amber-400">VIP STATUS</span>
      </motion.div>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="text-xl text-background/80 mb-2"
      >
        You attended
      </motion.p>

      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.6, type: "spring" }}
      >
        <AnimatedCounter
          value={count}
          className="text-7xl md:text-8xl font-bold text-amber-400"
        />
      </motion.div>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
        className="text-2xl text-background mt-2"
      >
        Secret {count === 1 ? "Salon" : "Salons"}
      </motion.p>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="text-background/60 mt-4"
      >
        One of the exclusive few! ✨
      </motion.p>
    </div>
  );
};

export default SalonsSlide;
